import { cartSkuSchema, type CartSku as CartSku } from "./CartSku";
import { z } from "zod";

export const cartAmountSchema = z.object({
	currencyCode: z.string(),
	subTotal: z.number(),
	couponAmount: z.number(),
	rewardPointAmount: z.number(),
	processingFee: z.number(),
	smsMessageFee: z.number(),
	netAmount: z.number(),
})
export const cartSchema = z.object({
	cartId: z.string(),
	couponCodes: z.array(z.string()).optional(),
	isPaypalSupported: z.boolean(),
	paypalExchangeRate: z.number(),
	// userCurrencyCode: z.string(),
	// userCurrencyAmount: z.number(),
	// couponCodeAmount: z.number(),
	// rewardsPointsAmount: z.number(),
	// processingFee: z.number(),
	// smsMessageFee: z.number(),
	cartAmount: cartAmountSchema,
	rewardsPointsEarned: z.number(),
	rewardPointsUsed: z.number(),
	guestEmail: z.string(),
	isAnonymous: z.boolean(),
	hasGuestEmail: z.boolean(),
	cartSkus: z.array(cartSkuSchema),
	paymentProvider: z.string(),
	// ipAddress: z.string(),
	// ipCountryCode: z.string(),
})

export type CartType = z.infer<typeof cartSchema>;
export type CartAmountType = z.infer<typeof cartAmountSchema>;
// export type CartType = {
// 	cartId: number;
// 	ipAddress: string;
// 	ipCountryCode: string;
// 	isPaypalSupported: boolean;
// 	paypalExchangeRate: number;
// 	couponCode: string;
// 	userCurrencyCode: string;
// 	userCurrencyAmount: number;
// 	cartAmount: CartAmountType;
// 	couponCodeAmount: number;
// 	rewardsPointsAmount: number;
// 	processingFee: number;
// 	smsMessageFee: number;
// 	rewardsPointsEarned: number;
// 	rewardPointsUsed: number;
// 	isAnonymous: boolean;
// 	hasGuestEmail: boolean;
// 	guestEmail: string;
// 	cartSkus: CartSku[];
// };


// interface CartAmountType {
// 	currencyCode: string;
// 	subTotal: number;
// 	couponAmount: number;
// 	rewardPointAmount: number;
// 	processingFee: number;
// 	smsMessageFee: number;
// 	netAmount: number;
// }
